module.exports = __webpack_public_path__ + "img/balao_balao_1.2324d5a5.svg";